import {
  ChangeDetectionStrategy,
  Component,
  OnInit, TemplateRef,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { CdkPortalOutlet, TemplatePortal } from '@angular/cdk/portal';

@Component({
  selector: 'mcrai-tooltip',
  template: `<ng-template cdkPortalOutlet></ng-template>
<ng-container>{{ text }}</ng-container>
`,
  styles: [`.mcrai-tooltip{display:block;padding:10px 20px}`],
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.mcrai-tooltip]': 'true'
  }
})
export class TooltipComponent implements OnInit {
  @ViewChild(CdkPortalOutlet) private _portalOutlet: CdkPortalOutlet;

  private _text: string;
  get text(): string {
    return this._text;
  }

  constructor(
    private _viewContainerRef: ViewContainerRef
  ) { }

  ngOnInit() { }

  public withContent(content: string | TemplateRef<any>): void {
    if (typeof content === 'string') {
      this._text = content;
    } else {
      const portal = new TemplatePortal(content, this._viewContainerRef);

      this._portalOutlet.attachTemplatePortal(portal);
    }
  }

}
